import { NEWS_PORTAL_TYPES } from 'volto-ministerio-publico-federal/constants';

/** Campo Choice da classificação LGPD (behavior `privacidade_dados`). */
export const PRIVACIDADE_FIELD = 'privacidade_dados';
/** Campo Bool, oculto no formulário, que guarda a declaração de ciência. */
export const DECLARACAO_FIELD = 'declaracao_dados_protegidos';

export const DECLARACAO_TEXTO =
  'Estou ciente da presença de dados pessoais e/ou sensíveis e declaro que foram adotadas as medidas necessárias para sua proteção, em conformidade com a LGPD e com as diretrizes institucionais aplicáveis.';

const CLASSIFICACOES_COM_DADOS = ['dados_pessoais', 'dados_sensiveis'];

/**
 * O Choice chega como string (valor escolhido no select) ou como
 * `{ token, title }` (valor vindo do `plone.restapi` ao editar).
 */
export const tokenPrivacidade = (value: unknown): string | undefined => {
  if (typeof value === 'string') return value;
  if (value && typeof value === 'object' && 'token' in value) {
    const { token } = value as { token?: unknown };
    return typeof token === 'string' ? token : undefined;
  }
  return undefined;
};

/** Dados pessoais ou sensíveis: a declaração de ciência passa a ser exigida. */
export const exigeDeclaracaoDados = (value: unknown): boolean => {
  const token = tokenPrivacidade(value);
  return token !== undefined && CLASSIFICACOES_COM_DADOS.includes(token);
};

/**
 * Notícia com dados pessoais/sensíveis e sem a declaração marcada: o
 * formulário não pode ser salvo (o backend também recusa —
 * `subscribers/declaracao_dados_protegidos.py`).
 */
export const declaracaoPendente = (
  type: string | undefined,
  formData: Record<string, unknown> | undefined,
): boolean => {
  if (!type || !NEWS_PORTAL_TYPES.includes(type) || !formData) return false;
  return (
    exigeDeclaracaoDados(formData[PRIVACIDADE_FIELD]) &&
    formData[DECLARACAO_FIELD] !== true
  );
};
